// Takes an array of options, returns a { value, label } object
// to make react-select happy

import { getTeamLabel } from '../services/helpers';

export const TransformToOption = (value, label) => {
  return {
    value,
    label,
  };
};

export const TransformToSelectOptions = (options, valueKey, labelKey) => {
  return options.map((option) => {
    return TransformToOption(option[valueKey], option[labelKey]);
  });
};

export const getUserLabel = (userInfo, t) => {
  const { firstName, lastName, fullName, email, fields, displayName } =
    userInfo || {};

  if (displayName) {
    return displayName;
  }

  const fallback =
    typeof t === 'function' ? `(${t('No Email')})` : '(No Email)';

  // this means userInfo is records endpoint data
  if (fields && typeof fields === 'object' && !Array.isArray(fields)) {
    let firstName = '';
    let lastName = '';
    let email = '';

    for (const field of Object.values(fields)) {
      if (field.name === 'first_name') {
        firstName = field.value;
      }
      if (field.name === 'last_name') {
        lastName = field.value;
      }
      if (field.name === 'email') {
        email = field.value;
      }
    }

    let label = `${firstName} ${lastName}`.trim();

    if (email) {
      label = `${label} (${email})`.trim();
    }

    return label || fallback;
  }

  const names = fullName ? [fullName] : [firstName, lastName];

  return (
    [...names, email && `(${email})`].filter(Boolean).join(' ') || fallback
  );
};

export const convertToTeamOption = (option) => {
  const label = getTeamLabel(option);
  return {
    value: option.id,
    label,
    data: {
      ...option,
      displayName: label,
    },
  };
};
